import { Link } from "react-router-dom";
import { Flame, Heart } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import type { User } from "@/contexts/AuthContext";

export default function Footer(): React.JSX.Element {
  const { user } = useAuth();
  const isLoggedIn = user && typeof user === "object";
  const isAdminAccount = isLoggedIn && (user as User).role === "admin";

  return (
    <footer className="relative border-t border-cream-200 bg-cream-100 overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          background:
            "radial-gradient(60% 40% at 80% 0%, rgba(225,29,72,0.15), transparent 70%), radial-gradient(40% 30% at 10% 100%, rgba(236,72,153,0.12), transparent 70%)",
        }}
      />
      <div className="container-custom py-16 grid grid-cols-1 md:grid-cols-12 gap-10 relative">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-heat-grad-deep text-white shadow-heat-glow">
              <Flame className="w-4 h-4" aria-hidden="true" />
            </span>
            <span className="font-display font-semibold text-xl tracking-tight text-ink-900">
              forfada<span className="text-heat-500">.</span>
            </span>
          </div>
          <p className="mt-5 text-sm text-ink-700 max-w-md leading-relaxed">
            A plataforma Oficial das Forfadas, encontre exatamente o que precisa, perto de casa, online ou presencial.
          </p>
          <div className="mt-6 flex items-center justify-center gap-2 px-4 py-2 rounded-full bg-white/60 border border-cream-200 backdrop-blur-sm text-xs w-full md:w-auto md:inline-flex">
            <span className="w-2 h-2 rounded-full bg-heat-500 glow-pulse" />
            <span className="font-semibold text-ink-700">Conteúdo direcionado a maiores de 18 anos</span>
          </div>
        </div>

        <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
          <div>
            <h4 className="overline mb-4">Plataforma</h4>
            <ul className="space-y-2.5 text-sm text-ink-700">
              <li><Link to="/" className="link-underline hover:text-heat-700">Buscar</Link></li>
              <li><Link to="/publicar" className="link-underline hover:text-heat-700">Anunciar Agora</Link></li>
              <li><Link to="/como-funciona" className="link-underline hover:text-heat-700">Como Funciona</Link></li>
              <li><Link to="/artigos" className="link-underline hover:text-heat-700">Artigos</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="overline mb-4">Conta</h4>
            <ul className="space-y-2.5 text-sm text-ink-700">
              {!isLoggedIn && (
                <>
                  <li><Link to="/login" className="link-underline hover:text-heat-700">Entrar</Link></li>
                  <li><Link to="/registrar" className="link-underline hover:text-heat-700">Criar Conta</Link></li>
                </>
              )}
              {isLoggedIn && (
                <li>
                  <Link to={isAdminAccount ? "/admin" : "/dashboard"} className="link-underline hover:text-heat-700">
                    {isAdminAccount ? "Admin" : "Meu Painel"}
                  </Link>
                </li>
              )}
              <li><Link to="/fale-conosco" className="link-underline hover:text-heat-700">Suporte</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="overline mb-4">Legal</h4>
            <ul className="space-y-2.5 text-sm text-ink-700">
              <li><Link to="/termos" className="link-underline hover:text-heat-700">Termos de Uso</Link></li>
              <li><Link to="/privacidade" className="link-underline hover:text-heat-700">Privacidade</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-cream-200 relative">
        <div className="container-custom py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-ink-500">
          <p className="flex items-center gap-1.5">
            © {new Date().getFullYear()} forfada.com — feito com
            <Heart className="w-3.5 h-3.5 fill-heat-500 text-heat-500" /> no Brasil.
          </p>
          <p className="font-mono tracking-tight uppercase">Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  );
}